import React from 'react';
import "../template-file-css/document-file-template.css";


export const GHP_IFISafetyPlan = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_IFISafetyPlan' className='file-pdf-document'>
            <div className='file-template'>



                <p>
                    <strong>NOTE TO CLINICAN:</strong>
                    Safety plan should be completed during the onset of services individual and family. Safety plan should be reviewed during the
                    course of services and modified as necessary. Please identify steps to be taken by individual, parent/guardian, DFCS, DJJ, family members, and identified
                    trusted adult during a crisis situation or safety concern (Ex: domestic violence, suicidal ideation, runaway). Help individual/family identify triggers, warning
                    signs, and coping skills on page 2. Copy of Safety/Crisis Plan should be given to the individual/family.
                </p>
                <h2>Safety Factor #1</h2>
                <h3>Steps</h3>
                <p>
                    <span className="eleHeader">1)</span>
                    <textarea id="txt_SF1_Step1" name="txt_SF1_Step1" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">2)</span>
                    <textarea id="txt_SF1_Step2" name="txt_SF1_Step2" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">3)</span>
                    <textarea id="txt_SF1_Step3" name="txt_SF1_Step3" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">4)</span>
                    <textarea id="txt_SF1_Step4" name="txt_SF1_Step4" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">5)</span>
                    <textarea id="txt_SF1_Step5" name="txt_SF1_Step5" className="add-only "></textarea></p>






                <h2>Safety Factor #2</h2>
                <h3>Steps</h3>
                <p>
                    <span className="eleHeader">1)</span>
                    <textarea id="txt_SF2_Step1" name="txt_SF2_Step1" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">2)</span>
                    <textarea id="txt_SF2_Step2" name="txt_SF2_Step2" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">3)</span>
                    <textarea id="txt_SF2_Step3" name="txt_SF2_Step3" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">4)</span>
                    <textarea id="txt_SF2_Step4" name="txt_SF2_Step4" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">5)</span>
                    <textarea id="txt_SF2_Step5" name="txt_SF2_Step5" className="add-only "></textarea></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className="eleHeader w-750;">Triggers/Stressors</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbBeingAlone" name="cbBeingAlone1" value="1" className="add-only" />
                            Being alone/feeling lonely
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbBeingDisrespected" name="cbBeingDisrespected1" value="1" className="add-only" />
                            Being disrespected
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbBeingReminded" name="cbBeingReminded1" value="1" className="add-only" />
                            Being reminded of the rules
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbBeingAround" name="cbBeingAround1" value="1" className="add-only" />
                            Being around people
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbMultipleCommand" name="cbMultipleCommand1" value="1" className="add-only" />
                            Multiple commands at once
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbLoudTone" name="cbLoudTone1" value="1" className="add-only" />
                            Loud tone of voice
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbBeingTouched" name="cbBeingTouched1" value="1" className="add-only" />
                            Being touched
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbHumorSarcasm" name="cbHumorSarcasm1" value="1" className="add-only" />
                            Humor or sarcasm
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbBeingIgnored" name="cbBeingIgnored1" value="1" className="add-only" />
                            Being ignored
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbNotBeing" name="cbNotBeing1" value="1" className="add-only" />
                            Not being listened to
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbTellingMe" name="cbTellingMe1" value="1" className="add-only" />
                            Telling me to "calm down"
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbDarkness" name="cbDarkness1" value="1" className="add-only" />
                            Darkness
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbFeelingPressured" name="cbFeelingPressured1" value="1" className="add-only" />
                            Feeling pressured
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbBeingTeased" name="cbBeingTeased1" value="1" className="add-only" />
                            Being teased/made fun of
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbPeerConflict" name="cbPeerConflict1" value="1" className="add-only" />
                            Peer conflict
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbFamilyConflict" name="cbFamilyConflict1" value="1" className="add-only" />
                            Family conflict
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbLackPrivacy" name="cbLackPrivacy1" value="1" className="add-only" />
                            Lack of privacy/invading my space
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbContactFamily" name="cbContactFamily1" value="1" className="add-only" />
                            Contact with family
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbBeingTold" name="cbBeingTold1" value="1" className="add-only" />
                            Being told "no"
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbParticularPerson" name="cbParticularPerson1" value="1" className="add-only" />
                            Particular person:
                            <input type="text" id="txtParticularPerson" name="txtParticularPerson" className="add-only" />
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbLosing" name="cbLosing" value="1" className="add-only" />
                            Losing at something
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbChangeEnvironment" name="cbChangeEnvironment1" value="1" className="add-only" />
                            Change in environment
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbParticularYear" name="cbParticularYear1" value="1" className="add-only" />
                            Particular time of year:
                            <input type="text" id="txtParticularYear" name="txtParticularYear" className="add-only" />
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbParticularDay" name="cbParticularDay1" value="1" className="add-only" />
                            Particular time of day:
                            <input type="text" id="txtParticularDay" name="txtParticularDay" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbGettingBad" name="cbGettingBad1" value="1" className="add-only" />
                            Getting a bad grade
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbParticularLocation" name="cbParticularLocation1" value="1" className="add-only" />
                            Particular location:
                            <input type="text" id="txtParticularLocation" name="txtParticularLocation" className="add-only" />
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbFinancialIssue" name="cbFinancialIssue1" value="1" className="add-only" />
                            Financial issues
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbOther" name="cbOther_1" value="1" className="add-only" />
                            Other:
                            <input type="text" id="txtOther_1" name="txtOther_1" className="add-only" />
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbOther" name="cbOther_2" value="1" className="add-only" />
                            Other:
                            <input type="text" id="txtOther_2" name="txtOther_2" className="add-only" />
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbOther" name="cbOther_3" value="1" className="add-only" />
                            Other:
                            <input type="text" id="txtOther_3" name="txtOther_3" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750" >
                            <input type="checkbox" id="cbNegative" name="cbNegative1" value="1" className="add-only" />
                            Negative thinking/thoughts about self or others
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750" >
                            <span className="eleHeader w-750;">Warning signs</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbNotTaking" name="cbNotTaking1" value="1" className="add-only" />
                            Not taking medication
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbSweating" name="cbSweating1" value="1" className="add-only" />
                            Sweating
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbRedFaced" name="cbRedFaced1" value="1" className="add-only" />
                            Red faced
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbActingHyper" name="cbActingHyper1" value="1" className="add-only" />
                            Acting hyper
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbBeingRude" name="cbBeingRude1" value="1" className="add-only" />
                            Being rude
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbBeingImpatient" name="cbBeingImpatient1" value="1" className="add-only" />
                            Being impatient
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbEatingDrinking" name="cbEatingDrinking1" value="1" className="add-only" />
                            Eating or drinking more
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbEatingDrinkingLess" name="cbEatingDrinkingLess1" value="1" className="add-only" />
                            Eating or drinking less
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbCursing" name="cbCursing1" value="1" className="add-only" />
                            Cursing/swearing
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbBreathingHard" name="cbBreathingHard1" value="1" className="add-only" />
                            Breathing hard
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbPacing" name="cbPacing1" value="1" className="add-only" />
                            Pacing
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbBeingVeryQuiet" name="cbBeingVeryQuiet1" value="1" className="add-only" />
                            Being very quiet
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbRacingHeart" name="cbRacingHeart1" value="1" className="add-only" />
                            Racing heart
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbBeingLoud" name="cbBeingLoud1" value="1" className="add-only" />
                            Being loud
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbBouncingLegs" name="cbBouncingLegs1" value="1" className="add-only" />
                            Bouncing legs
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbCrying" name="cbCrying1" value="1" className="add-only" />
                            Crying
                        </td>
                        <td className="w-450" >
                            <input type="checkbox" id="cbNotTakingCare" name="cbNotTakingCare1" value="1" className="add-only" />
                            Not taking care of myself (decreased hygiene)
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbClenchingTeeth" name="cbClenchingTeeth1" value="1" className="add-only" />
                            Clenching teeth
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbClenchingFists" name="cbClenchingFists1" value="1" className="add-only" />
                            Clenching fists
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbSleepingLess" name="cbSleepingLess1" value="1" className="add-only" />
                            Sleeping less
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbSleepingMore" name="cbSleepingMore1" value="1" className="add-only" />
                            Sleeping more
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbRocking" name="cbRocking1" value="1" className="add-only" />
                            Rocking
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbCuttingSelf" name="cbCuttingSelf1" value="1" className="add-only" />
                            Cutting/self-harm
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbIsolating" name="cbIsolating1" value="1" className="add-only" />
                            Isolating/avoiding people
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbCant" name="cbCant1" value="1" className="add-only" />
                            Can't sit still
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbDamagingThings" name="cbDamagingThings1" value="1" className="add-only" />
                            Damaging Things
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbHeadache" name="cbHeadache1" value="1" className="add-only" />
                            Headache
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbStomachAche" name="cbStomachAche1" value="1" className="add-only" />
                            Stomach ache
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbLackOfInterest" name="cbLackOfInterest1" value="1" className="add-only" />
                            Lack of interest in usual activities
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250" >
                            <input type="checkbox" id="cbDrugsUse" name="cbDrugsUse1" value="1" className="add-only" />
                            Drug use/alcohol use
                        </td>
                        <td className="w-250" >
                            <input type="checkbox" id="cbWarning_Other" name="cbWarning_Other1" value="1" className="add-only" />
                            Other:
                            <input type="text" id="txtWarning_Other" name="txtWarning_Other" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750" >
                            <span className="eleHeader w-750;">Coping Skills</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbAffirmations" name="cbAffirmations1" value="1" className="add-only" />
                            Affirmations "I can do this", "I'm okay"
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbTimeOut" name="cbTimeOut1" value="1" className="add-only" />
                            Time out
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbTalkingAdult" name="cbTalkingAdult1" value="1" className="add-only" />
                            Talking with trusted adult
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbTalkingTherapist" name="cbTalkingTherapist1" value="1" className="add-only" />
                            Talking with therapist or paraprofessional
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbTalkingWithFriends" name="cbTalkingWithFriends1" value="1" className="add-only" />
                            Talking with friends
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbDeep" name="cbDeep" value="1" className="add-only" />
                            Deep breathing
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbExercising" name="cbExercising1" value="1" className="add-only" />
                            Exercising
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbTakingCool" name="cbTakingCool1" value="1" className="add-only" />
                            Taking a hot or cool shower
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbRipping" name="cbRipping1" value="1" className="add-only" />
                            Ripping up paper
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbBounding" name="cbBounding1" value="1" className="add-only" />
                            Bounding a ball
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbDrawing" name="cbDrawing1" value="1" className="add-only" />
                            Drawing/coloring/sketching
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbBeingAroundOthers" name="cbBeingAroundOthers1" value="1" className="add-only" />
                            Being around others
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbListeningMusic" name="cbListeningMusic1" value="1" className="add-only" />
                            Listening to music
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbWashingFace" name="cbWashingFace1" value="1" className="add-only" />
                            Washing face
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbScreaming" name="cbScreaming1" value="1" className="add-only" />
                            Screaming into a pillow
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbReading" name="cbReading1" value="1" className="add-only" />
                            Reading
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbWatching" name="cbWatching1" value="1" className="add-only" />
                            Watching TV/YouTube/Netflix
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbDoingTask" name="cbDoingTask1" value="1" className="add-only" />
                            Doing a task/chore
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbWriting" name="cbWriting1" value="1" className="add-only" />
                            Writing in journal
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbPlaying" name="cbPlaying1" value="1" className="add-only" />
                            Playing games/cards
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbHolding" name="cbHolding1" value="1" className="add-only" />
                            Holding ice in hand
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbDrinking" name="cbDrinking1" value="1" className="add-only" />
                            Drinking water/eating snack
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbSqueezing" name="cbSqueezing1" value="1" className="add-only" />
                            Squeezing a ball
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbPunching" name="cbPunching1" value="1" className="add-only" />
                            Punching a pillow
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbAskingHug" name="cbAskingHug1" value="1" className="add-only" />
                            Asking for a hug
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbAskingHelp" name="cbAskingHelp1" value="1" className="add-only" />
                            Asking for help
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbCoping_Crying" name="cbCoping_Crying1" value="1" className="add-only" />
                            Crying
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbLying" name="cbLying1" value="1" className="add-only" />
                            Lying down/nap
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbTakingWalk" name="cbTakingWalk1" value="1" className="add-only" />
                            Taking a walk (within a limited distance)
                        </td>
                        <td className="w-375" >
                            <input type="checkbox" id="cbSinging" name="cbSinging1" value="1" className="add-only" />
                            Singing/rapping
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375" >
                            <input type="checkbox" id="cbCoping_Other" name="cbCoping_Other1" value="1" className="add-only" />
                            Other:
                            <input type="text" id="txtCoping_Other" name="txtCoping_Other" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750" >
                            <span className="eleHeader">Ways to keep me safe</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbSecureMedications" name="cbSecureMedications1" value="1" className="add-only" />
                            Secure all medications
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbSecureItems" name="cbSecureItems1" value="1" className="add-only" />
                            Secure all sharp items (knives, razors, scissors, etc)
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750" >
                            <input type="checkbox" id="cbLimitedAccess" name="cbLimitedAccess1" value="1" className="add-only" />
                            Limit access to alcohol
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750" >
                            <input type="checkbox" id="cbSecureWeapons" name="cbSecureWeapons1" value="1" className="add-only" />
                            Secure weapons and firearms in locked box or safe
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750" >
                            <input type="checkbox" id="cbIllegalDrugs" name="cbIllegalDrugs1" value="1" className="add-only" />
                            Do not have illegal drugs in the home
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750" >
                            <input type="checkbox" id="cbSecureHarmful" name="cbSecureHarmful1" value="1" className="add-only" />
                            Secure harmful liquids (bleach, antifreeze, ammonia, cleaning products)
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750" >
                            <input type="checkbox" id="cbLimitAccess" name="cbLimitAccess1" value="1" className="add-only" />
                            Limit access to materials that can be used in suicidal behaviors such as:
                            ropes, cords, belts, chains, etc
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbWays_Other" name="cbWays_Other1" value="1" className="add-only" />
                            Other:
                            <input type="text" id="txtWays_Other" name="txtWays_Other" className="add-only" />

                        </td>
                    </tr>
                </table>
                <p><span className="eleHeader">Things to consider</span></p>

                <ul>
                    <li>Secure means to LOCK and LIMIT ACCESS</li>
                    <li>Medication lock boxes: can be purchased at Walmart, Target, or pharmacies. $10-$100 </li>
                    <li>Safe: can be purchased at Walmart, Target, or any home improvement store such as Home Deport or Lowe's. $10-$100</li>
                </ul>
                <h3>The following are trusted adults that I will contact when in crisis:</h3>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader w-375;">1. Name/Relationship</span>
                            <input type="text" id="txtNameRelationship_1" name="txtNameRelationship_1" className="add-only" />

                        </td>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Contact Number</span>
                            <input type="text" id="txtContact_1" name="txtContact_1" className="add-only " />

                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader w-375;">2. Name/Relationship</span>
                            <input type="text" id="txtNameRelationship_2" name="txtNameRelationship_2" className="add-only " />

                        </td>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Contact Number</span>
                            <input type="text" id="txtContact_2" name="txtContact_2" className="add-only " />

                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader w-375;">3. Therapist</span>
                            <input type="text" id="txtTherapist" name="txtTherapist" className="add-only " />

                        </td>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Contact Number</span>
                            <input type="text" id="txtContact_3" name="txtContact_3" className="add-only " />

                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader w-375;">4. Paraprofessional/Team Member</span>
                            <input type="text" id="txtTeamMember" name="txtTeamMember" className="add-only " />

                        </td>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Contact Number</span>
                            <input type="text" id="txtContact_4" name="txtContact_4" className="add-only " />

                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader w-375;">5. Georgia Crisis and Access Line (available 24/7)</span>
                            <input type="text" id="txtGeorgia" name="txtGeorgia" className="add-only " />

                        </td>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Contact Number</span>
                            <input type="text" id="txtContact_5" name="txtContact_5" value="1-800-715-4225" className="add-only " />

                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader w-375;">6. After Hours GHP Crisis Line</span>
                            <input type="text" id="txtGHP" name="txtGHP" className="add-only " />

                        </td>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Contact Number</span>
                            <input type="text" id="txtContact_6" name="txtContact_6" className="add-only " />

                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-600 signature"></td>
                        <td className="w-150 signature"></td>
                    </tr>
                    <tr>
                        <td className="small w-600">Individual Signature</td>
                        <td className="small w-150 text-center">Date</td>
                    </tr>
                    <tr>
                        <td className="w-600 signature"></td>
                        <td className=" w-150 signature"></td>
                    </tr>
                    <tr>
                        <td className="small w-600">Parent/Guardian Signature</td>
                        <td className="small  w-150  text-center">Date</td>
                    </tr>
                    <tr>
                        <td className="w-600 signature"></td>
                        <td className=" w-150 signature"></td>
                    </tr>
                    <tr>
                        <td className="small w-600">Therapist Signature</td>
                        <td className="small  w-150  text-center">Date</td>
                    </tr>
                    <tr>
                        <td className="w-600 signature"></td>
                        <td className=" w-150 signature"></td>
                    </tr>
                    <tr>
                        <td className="small w-600">Probation Officer/DFCS (if available)</td>
                        <td className="small  w-150  text-center">Date</td>
                    </tr>
                </table>
            </div>
        </form>
    )
}
